<template>
  <div class="exercise-exam">
    <div class="exercise-exam__head">
      <div class="exercise-exam__head__filter display-flex-center">
        <div class="input-custom-icon item select-custom item--type">
          <select name="typeId" @change="handleFilterType" class="color_bg_gray_light border-0 border-rd-20 form-h30 primary-color-txt font-sanpro-light full-width">
            <option value="0">Đề thi - tất cả</option>
            <option value="1">Đã hoàn thành</option>
            <option value="2">Chưa hoàn thành</option>
            <option value="3">Chưa làm</option>
          </select>
          <i class="icon-arrow-down primary-color"></i>
        </div>
        <div class="input-custom-icon item item--keyword">
          <input type="text" name="keyword" class="color_bg_gray_light border-0 border-rd-20 form-h30 primary-color-txt font-sanpro-light full-width" placeholder="Tìm kiếm" v-model.lazy="keyword" v-debounce="300" />
          <i class="icon-search primary-color"></i>
        </div>
      </div>
    </div>
    <div class="exercise-exam__body">
      <template v-if="dataSource && dataSource.length > 0">
        <div class="row">
          <ItemExam v-for="(item, index) of dataSource" :key="index" :dataSource="item" class="col-md-3 col-sm-6" />
        </div>
      </template>
      <p v-else class="m-3 secondary-color-txt text-center font-size-20">Đang cập nhật dữ liệu lên hệ thống</p>
    </div>
    <div id="data_end"></div>
    <!-- <div class="exercise-exam__footer">
      <Pagination v-if="dataPaging && dataPaging.totalPage > 1" :totalPage="dataPaging.totalPage" :page="paramsFilterExExam.pageIndex" @eventPagination="changePage" />
    </div> -->
  </div>
</template>

<script>
  import debounce from "@/directives/debounce";
  import { mapState, mapActions } from 'vuex'
  import { STORE_KEY, LOCAL_SAVE_QUESTIONS_WORKED } from './../../_store/constants'

  export default {
    name: 'ExerciseExam',
    props: {
      dataSource: Array,
      dataPaging: Object
    },
    directives: { debounce },
    components: {
      ItemExam: () => import('./ItemExam.vue'),
      Pagination: () => import('@/components/Pagination.vue')
    },
    data () {
      return {
        keyword: '',
        elmEndItem: null,
        observer: null
      }
    },
    computed: {
      ...mapState(STORE_KEY, ['paramsFilterExExam'])
    },
    watch: {
      keyword: "handleFilterKeyword",
      dataPaging (newVal) {
        if (this.elmEndItem && newVal) {
          this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
          this.observer.observe(this.elmEndItem)
        }
      }
    },
    mounted () {
      localStorage.removeItem(LOCAL_SAVE_QUESTIONS_WORKED)
      this.elmEndItem = document.getElementById('data_end')
    },
    methods: {
      ...mapActions(STORE_KEY, ['acSetParamFilterExam']),

      handleFilterKeyword () {
        this.acSetParamFilterExam({...this.paramsFilterExExam, keyword: this.keyword, pageIndex: 1})
      },

      handleFilterType (evt) {
        let value = parseInt(evt.target.value)
        this.acSetParamFilterExam({...this.paramsFilterExExam, typeId: value, pageIndex: 1})
      },

      changePage (val) {
        this.acSetParamFilterExam({...this.paramsFilterExExam, pageIndex: val})
      },

      handleScrollEnd () {
        if (this.paramsFilterExExam.pageIndex < this.dataPaging.totalPage) {
          this.acSetParamFilterExam({...this.paramsFilterExExam, pageIndex: this.paramsFilterExExam.pageIndex + 1})
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .exercise-exam {
    &__head {
      .item {
        &--type {
          width: 15%;
          margin-right: 15px;
        }

        &--keyword {
          width: 30%;
        }
      }
    }

    &__body {
      padding: 30px 0;
    }
  }

  @media screen and ( max-width: 575px ) {
    .exercise-exam {
      &__head {
        &__filter {
          display: block;
        }
        .item {
          &--type {
            margin: 0 0 10px;
          }

          &--type, &--keyword {
            width: 100%;
          }
        }
      }

      &__body {
        padding: 15px 0;      }
    }
  }
</style>